import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
// material
import { alpha, experimentalStyled as styled } from '@mui/material/styles';
import {
  Box,
  Collapse,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
// ----------------------------------------------------------------------

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  ...theme.typography.body2,
  height: 52,
  textTransform: 'capitalize',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  fontSize: '12px',
  fontWeight: 500,
  color: 'white',
  '&.isActiveRoot': {
    color: '#5FCFD1 !important',
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: 'rgba(35, 210, 210, 0.1) !important',
    borderRadius: '4px',
    '&:before': {
      top: 0,
      right: 0,
      width: 3,
      bottom: 0,
      content: "''",
      position: 'absolute',
      // backgroundColor: theme.palette.primary.main
    }
  },
  '&.isActiveSub': {
    color: '#5FCFD1 !important',
    fontWeight: theme.typography.fontWeightLight,
    '& .subIcon:before': {
      transform: 'scale(1)',
      backgroundColor: theme.palette.primary.main
    }
  }
}));

const SubIconStyle = styled('span')(({ theme }) => ({
  width: 22,
  height: 22,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:before': {
    width: 4,
    height: 4,
    content: "''",
    display: 'block',
    borderRadius: '50%',
    backgroundColor: theme.palette.text.disabled,
    transition: theme.transitions.create('transform')
  }
}));

// ----------------------------------------------------------------------

SidebarItem.propTypes = {
  level: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  href: PropTypes.string,
  info: PropTypes.element,
  icon: PropTypes.element,
  open: PropTypes.bool,
  children: PropTypes.node
};

export default function SidebarItem({
  level,
  title,
  href,
  info,
  icon,
  open = false,
  children
}) {
  const [show, setShow] = useState(open);
  const isSubItem = level > 0;

  const handleShow = () => {
    setShow((show) => !show);
  };
  const userData = useSelector((state) => state.authJwt.oAuthUser);
  const [roleId, setRoleId] = useState(null);
  useEffect(() => {
    if(userData?.id) {
      setRoleId(userData?.roles[0]?.id);
    }
  }, [userData])
  if (children) {
    return (
      <div className={roleId !== 1 && title == 'Admin' ? 'd-none': ''}>
        <ListItemStyle
          button
          disableGutters
          onClick={handleShow}
          className={open ? 'isActiveRoot' : ''}
        >
          <ListItemIcon>{icon && icon}</ListItemIcon>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Box
            component={Icon}
            icon={show ? arrowIosDownwardFill : arrowIosForwardFill}
            sx={{ width: 16, height: 16, ml: 1 }}
          />
        </ListItemStyle>

        <Collapse in={show}>{children}</Collapse>
      </div>
    );
  }

  return (
    <ListItemStyle
      button
      to={href}
      exact={open}
      disableGutters
      component={RouterLink}
      activeClassName={isSubItem ? 'isActiveSub' : 'isActiveRoot'}
      isActive={(match, location) => {
        if (!match) {
          return false;
        }

        const { url } = match;
        const { pathname } = location;
        const isMatch = url === pathname;

        if (!isSubItem) {
          return url.length && pathname.includes(url);
        }

        return isMatch;
      }}
    >
      <ListItemIcon>
        {isSubItem ? <SubIconStyle className="subIcon" /> : icon}
      </ListItemIcon>
      <ListItemText disableTypography primary={title} />

      {info && info}
    </ListItemStyle>
  );
}
